import { useEffect } from "react";
import { COMPANY } from "../data/site";

// Lightweight document head manager (title + meta + og) without extra deps.
const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const Seo = ({ title, description, path = "/" }) => {
  useEffect(() => {
    const fullTitle = title ? `${title} — ${COMPANY.name}` : COMPANY.name;
    document.title = fullTitle;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
    }
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", COMPANY.name);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", window.location.origin + path);
  }, [title, description, path]);

  return null;
};
